
// FancyDressActivity
import React from 'react';
import FlamelessCooking2025 from 'views/FlamelessCooking2025';

const FancyDressActivityPage = () => {
  return <FlamelessCooking2025/>;
};

export default FancyDressActivityPage;